export default __webpack_public_path__ + "static/media/Header_logo.1cbaa326.png";